import { Society } from 'types';

export const isSocietyConstituted = (society: Society): boolean =>
  !!(society?.constitutionDate || society?.operationsCount?.constitution);
